import PublicDocumentsList from "./public-documents-list";

export default PublicDocumentsList;
